export const environment = {
    // apiUrl2:'https://api.securepro.xyz/',
    apiUrl: 'https://secure-proxy-api-sandbox.sudoafrica.site/',
    jwtTokenEncryptionKey: 'Ajdie9384fdhfuhdueienAuSZ398D3xjaoeun9c8Mqmid302yQSiahfQ90183SAUDJD',
}